// extracted by mini-css-extract-plugin
module.exports = {"root":"product-quantity_root__m9fvY","button":"product-quantity_button__2F1ph","text":"product-quantity_text__2gFgX","dropdown":"product-quantity_dropdown___FumE"};